export const isRequired = (value) => {
  return (value && Array.isArray(value) && value.length === 0) || !value;
};
